var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import get from 'lodash/get';
import has from 'lodash/has';
import isPlainObject from 'lodash/isPlainObject';
import set from 'lodash/set';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import snakeCase from 'lodash/snakeCase';
export var ensureSafeChaining = function (object, path, defaultValue) {
    // Ensure the path is existed first
    if (!has(object, path)) {
        set(object, path, undefined);
    }
    // Set default value if you want to. (defaultValue !== undefined)
    if (defaultValue !== undefined && get(object, path) === undefined) {
        set(object, path, defaultValue);
    }
};
export var getObjNthItem = function (obj, nth) {
    if (!obj) {
        return undefined;
    }
    var index = nth - 1;
    var objKeys = Object.keys(obj);
    var targetKey = objKeys && objKeys[index];
    return obj[targetKey];
};
export var requestDummyData = function (method, url, data) {
    if (data === void 0) { data = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, endpoint;
        return __generator(this, function (_b) {
            _a = __read(url.split('?'), 1), endpoint = _a[0];
            return [2 /*return*/, {
                    config: {},
                    headers: {},
                    request: undefined,
                    status: 200,
                    statusText: '',
                    data: { data: data[endpoint][method], message: '', status: '200' },
                }];
        });
    });
};
export var snakeCaseObj = function (obj, removeWhitespace) {
    if (removeWhitespace === void 0) { removeWhitespace = true; }
    if (!isPlainObject(obj)) {
        return obj;
    }
    var res = {};
    Object.keys(obj).forEach(function (property) {
        var value = obj[property];
        if (isArray(value)) {
            value = value.map(function (item) { return snakeCaseObj(item); });
        }
        else if (isPlainObject(value)) {
            value = snakeCaseObj(value);
        }
        if (removeWhitespace) {
            if (isString(value)) {
                value = value.replace(/\\t$/, '').trim();
            }
        }
        res[snakeCase(property)] = value;
    });
    return res;
};
export var parseFormDataToObj = function (formData) {
    var e_1, _a;
    var object = {};
    try {
        for (var _b = __values(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (!(value instanceof File)) {
                object[key] = value;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return object;
};
export var serializeQueryString = function (obj, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.encode, encode = _c === void 0 ? true : _c, _d = _b.snakeKey, snakeKey = _d === void 0 ? false : _d;
    if (!obj) {
        return '';
    }
    return "?".concat(Object.keys(obj)
        .reduce(function (a, k) {
        if (Array.isArray(obj[k]) && obj[k].length > 0) {
            obj[k].forEach(function (val) {
                var key = snakeKey ? snakeCase(k) : k;
                var value = val;
                if (isString(value)) {
                    value = value.replace(/\\t$/, '').trim();
                }
                value = encode ? encodeURIComponent(value) : value;
                // @ts-ignore
                a.push("".concat(key, "[]=").concat(value));
            });
        }
        else if (obj[k] !== null && obj[k] !== undefined) {
            var key = snakeKey ? snakeCase(k) : k;
            var value = obj[k];
            if (isString(value)) {
                value = value.replace(/\\t$/, '').trim();
            }
            value = encode ? encodeURIComponent(value) : value;
            // @ts-ignore
            a.push("".concat(key, "=").concat(value));
        }
        return a;
    }, [])
        .join('&'));
};
